import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import useMonolithApiMutation from '@/hooks/api/useMonolithApiMutation';
import { SimpleErrorResponse } from '@/models/Error';

import { machineMigrationOpportunityOptOutPath } from './machineMigrationOpportunityOptOutPath';
import { machineMigrationOpportunityQueryKey } from './useMachineMigrationOpportunitiesShow';

type Request = { workflow: string };

const useMachineMigrationOpportunitiesOptOut = (
  appSlug: string,
  onSuccess: ({ workflow }: { workflow: string }) => void,
) => {
  const queryClient = useQueryClient();

  const [workflow, setWorkflow] = useState<string | null>(null);

  const { mutate, ...rest } = useMonolithApiMutation<void, SimpleErrorResponse, Request>(
    `${machineMigrationOpportunityOptOutPath(appSlug)}`,
    'PATCH',
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries({ queryKey: machineMigrationOpportunityQueryKey(appSlug) });
        onSuccess({ workflow: variables.workflow });
        setWorkflow(null);
      },
    },
  );

  return {
    mutate: ({ workflow }: { workflow: string }) => {
      setWorkflow(workflow);
      mutate({ workflow });
    },
    targetWorkflow: workflow,
    ...rest,
  };
};

export default useMachineMigrationOpportunitiesOptOut;
